import { useState } from "react"

import { ContentObjectItem } from "@vertesia/common"
import { FileSearch, Upload, Paperclip } from "lucide-react"

import { UploadDocumentsModal } from "@components/modals/UploadDocumentsModal"
import { DocumentSelectionOverlay } from "@components/overlays/DocumentSelectionOverlay"

import { Button } from "@ui/button"
import { Popover, PopoverContent, PopoverTrigger } from "@ui/popover"

interface FilesSelectionPanelProps {
    disabled?: boolean
    onChange: (documents: ContentObjectItem[]) => void
}
export function FilesSelectionPanel({ disabled = false, onChange }: Readonly<FilesSelectionPanelProps>) {
    const [open, setOpen] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)

    const [trigger, setTrigger] = useState(0)

    const handleOpenOverlay = () => {
        setTrigger(trigger + 1)
        setOpen(false)
    }

    return (
        <div className="flex flex-row items-center w-full">
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild disabled={disabled}>
                    <Button variant="icon" size="icon" className="border-none">
                        <Paperclip />
                    </Button>
                </PopoverTrigger>
                <PopoverContent side="bottom" align="end" className="p-1 w-45">
                    <Button variant="ghost" className="text-left justify-start w-full text-muted-foreground" onClick={handleOpenOverlay}>
                        <FileSearch /> Browse Vertesia
                    </Button>
                    <Button variant="ghost" className="text-left justify-start w-full text-muted-foreground" onClick={() => setModalOpen(true)}>
                        <Upload /> Upload File(s)
                    </Button>
                </PopoverContent>
            </Popover>
            <DocumentSelectionOverlay onObjMultipleSelection={onChange} trigger={trigger} />
            <UploadDocumentsModal open={modalOpen} onOpenChange={setModalOpen} onUploadDone={onChange} />
        </div>
    )
}
